var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell"},[_c('van-field',_vm._b({on:{"click":function($event){_vm.showPicker = true}},model:{value:(_vm.displaValue),callback:function ($$v) {_vm.displaValue=$$v},expression:"displaValue"}},'van-field',{
      ..._vm.fieldProps,
      readonly: true,
    },false)),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v},expression:"showPicker"}},[_c('inlineCalendar',_vm._b({attrs:{"defaultDate":_vm.defaultDate},on:{"change":_vm.onChange}},'inlineCalendar',_vm.calendarProps,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }